import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import useTranslation from "shared/helpers/hooks/useTranslation";
import AiAssistant from "./tabs/AiAssistant";
import DashboardStatistics from "./tabs/DashboardStatistics";
import PinnedSurveys from "./tabs/PinnedSurveys";

const Dashboard = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const t = useTranslation();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box px={2} py={4}>
      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          <Tab label={t("ai_module_title")} />
          <Tab label={t("dashboard")} />
          <Tab label={t("pinned_surveys")} />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box mt={2}>
        {currentTab === 0 && <AiAssistant />}

        {currentTab === 1 && <DashboardStatistics />}

        {currentTab === 2 && <PinnedSurveys />}
      </Box>
    </Box>
  );
};

export default Dashboard;
